exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wind {\n  height: 110%;\n  font-size: 110%;\n}\n", ""]);

// exports
